import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {useEffect, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {ObjUtil} from 'yougile-util'
import {Hub} from 'yougile-model'
import {CheckboxNew} from '@components/common/base/checkbox-new/checkbox-new'
import {Dialog} from '@components/common/base/dialog/dialog'
import {useLoggedInStore} from '@components/logged-in/logged-in-store'
import {Column} from '@extensions/column'
import {columnSort} from './column-sort'
import {SetNewOrderProps} from './types'

const TwContentContainer = tw.div`
  font-normal
  text-14
  leading-5
`

const TwShowLaterBlock = tw.div`
  mt-12
`

export const columnsSortPopupCtl = {
  setNewOrder: (props: SetNewOrderProps) => {
    void props
  }
}

export const ColumnsSortPopup = observer(() => {
  const [loggedInState, loggedInStore] = useLoggedInStore()
  const [showColumnsSortWarning, setShowColumnsSortWarning] =
    useState<boolean>(false)
  const [data, setData] = useState<SetNewOrderProps>()

  useEffect(() => {
    columnsSortPopupCtl.setNewOrder = props => {
      setTimeout(() => {
        setData(props)
      }, 100)
    }
  }, [])

  const onClose = () => {
    setData(undefined)
  }

  const onApply = () => {
    if (!data) {
      return
    }

    Column.invalidateTasksOrderCache(data.column.id)
    const order = Column.getTasksOrder(data.column)
    const tasks = order.getList() as Hub[]
    const origOrderTaskIds = tasks.map(t => t.id)

    const newTasks = columnSort({tasks, ...data})
    const newOrderTaskIds = newTasks.map(t => t.id)

    if (!ObjUtil.deepEqual(origOrderTaskIds, newOrderTaskIds, true)) {
      order.setEntities(newTasks)
    }

    if (showColumnsSortWarning) {
      loggedInStore.setBlockColumnSortWarning('true')
    }

    onClose()
  }

  if (loggedInState?.blockColumnSortWarning) {
    onApply()
    return null
  }

  const onChangeShowLaterCheckbox = () => {
    setShowColumnsSortWarning(prev => !prev)
  }

  if (!data) {
    return null
  }

  return (
    <Dialog
      close={onClose}
      submit={onApply}
      title={Lang.msg.columnOrder.confirmPopupTitle}
      width={370}
    >
      <TwContentContainer style={{letterSpacing: '-0.2px'}}>
        {Lang.msg.columnOrder.confirmPopupContent}
        <TwShowLaterBlock>
          <CheckboxNew
            value={showColumnsSortWarning}
            onChange={onChangeShowLaterCheckbox}
            label={Lang.msg.columnOrder.disableColumnSortDialog}
            labelClassName="!text-grey"
          />
        </TwShowLaterBlock>
      </TwContentContainer>
    </Dialog>
  )
})
